import { render, staticRenderFns } from "./ActivePackageCard.vue?vue&type=template&id=23189fb4&scoped=true"
import script from "./ActivePackageCard.vue?vue&type=script&lang=ts"
export * from "./ActivePackageCard.vue?vue&type=script&lang=ts"
import style0 from "./ActivePackageCard.vue?vue&type=style&index=0&id=23189fb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23189fb4",
  null
  
)

export default component.exports